import script from "./SignificantTags.vue?vue&type=script&setup=true&lang=js"
export * from "./SignificantTags.vue?vue&type=script&setup=true&lang=js"

import "./SignificantTags.vue?vue&type=style&index=0&id=2694a509&scoped=true&lang=css"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2694a509"]])

export default __exports__